module.exports = __webpack_public_path__ + "static/media/bee-badge.e8044759.png";